import * as React from "react";
import { useSelector } from "react-redux";

import { Box, Typography} from "@mui/material";

import Logo from "../../../ui-components/Logo";
import WebOnboardingButton from "../../../ui-components/Buttons/WebOnboardingButton";

export default function WebInfo({
        testLevel,
        onChangeWebStyleLayout = () => {}
    }) 
{
    const pStyle = {
        textAlign: "left",
        fontSize: "1.15em",
        fontWeight: "bold",
        marginBottom: "2em"
    }

	const client = useSelector((state) => state.client || {});

    React.useEffect(() => {
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: true,
            }
        });
    }, [onChangeWebStyleLayout]);

    const getTakenTimeDescription = testLevel === "vfh" ? "between 30 mins - 1 hour" : testLevel === "acsf4" ? "between 30 mins - 40 mins" : "up to 30 minutes";

	return (
		<React.Fragment>
			<Box sx={{
                textAlign: "center",
            }}>
                {client?.details?.logo?.absolute ? (
                    <Box component="img"
                        alt="logo"
                        src={client.details.logo.absolute}
                        style={{
                            maxWidth: "22rem",
                            maxHeight: "11rem",
                        }}
                    />
                ) : <Logo width="80px" />}
                <Box
                    sx={{
                        "@media (max-width: 1024px), (max-height: 768px)": {
                            padding: "12px",
                        },
                        "@media (max-width: 800px), (max-height: 600px)": {
                            padding: "12px",
                        },
                    }}
                >
                    <Typography component="p" sx={pStyle}>Before you start your course we want you to complete this quiz.</Typography>
                    <Typography component="p" sx={pStyle}>It will give us a clear picture of your current language, literacy and numeracy skills. This will help us to support you and offer you advice about your course.</Typography>
                    <Typography component="p" sx={pStyle}>The quiz can take {getTakenTimeDescription} to complete, but you do not have to finish it in one sitting.</Typography>
                    <Typography component="p" sx={pStyle}>Please contact {client?.details?.displayName} on {client?.details?.preferences?.learnerCorrespondence?.phone} or email any questions you have to {client?.details?.preferences?.learnerCorrespondence?.email}</Typography>
                </Box>
            </Box>
            <Box sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                textAlign: "center",
            }}>
                <WebOnboardingButton url="/form" title="Continue"/>
            </Box>
		</React.Fragment>
	);
}